import { KoButton, KoForm, KoFormBuilder,  KoLoader, KoModal, KoNano, KoSearch, KoSelect, KoTable, KoText, KoTitle, KoToast, KoTooltips, KoUserSelect } from 'packages';
import KoIcon from '@kwapio/icons';
import { useEffect, useState } from 'react';
import _cloneDeep from 'lodash/cloneDeep';
import styles from './assignee.module.scss';
import { workspaceAPI } from './workspace.service';
import { useSelector } from 'react-redux';
import { getCurrentAssignees } from 'shared/store/currentAssigneesSlice';
import { useDispatch } from 'react-redux';
import { getWorkspaceById } from 'shared/store/workspaceByIdSlice';
import { COLUMNS_GROUPS, COLUMNS_USERS } from './constant';


function AssignesUpdate({ workspaceId, workspaceName, assigneeForm, getWorkspace, createdBy }) {
  const [isLoading, setLoading] = useState(false);
  const users = useSelector(state => state?.users);
  const currentAssignees = useSelector(state => state?.currentAssignees);
  const dispatch = useDispatch();
  const groups = useSelector(state => state?.groups);
  const [currentRecord, setCurrentRecord] = useState();
  const [dataSource, setDataSource] = useState();
  const [isOpenDelete, setDeleteModal] = useState(false);
  const [addTeamMemberModal, setAddTeamMemberModal] = useState(false);
  const [orgUsers,setOrgUsers  ] = useState(users['data']);
  const [wosGroups, setWosGroups] = useState([]);
  const [isOpenGroupDelete, setDeleteGroupModal] = useState(false);

  useEffect(() => {
    dispatch(getCurrentAssignees(workspaceId));
  }, []);

  useEffect(() => {
    if (workspaceId) {
      if(currentAssignees['state'] === 'pending'){
        setLoading(true);
        return;
      }
      setLoading(false);
      let dataList = currentAssignees?.data?.map((item) => {
        return {
          ...item,
          status: 1
        };
      });
      setDataSource(dataList);
      const listAUserIds = new Set(dataList?.map(user => user.userId));
      const orgUserCopy= _cloneDeep(users['data']);
      const filteredListB = orgUserCopy.filter(user => !listAUserIds.has(user.userId));
      setOrgUsers(filteredListB);
      getGroups();
    }
  }, [currentAssignees]);


  const getGroups = () => {
    workspaceAPI.getworkspaceGroups(workspaceId).then(
      (data) => {
        setWosGroups(data['groups']);
      },
      (err) => {
      }
    );
  };

  console.log('currentAssignees', wosGroups);

  const handleAssigneeFinish = (val) => {
    if (!val['key']) {
      val['key'] = KoNano('TMS');
    }
    setLoading(true);
    let teams = {
      user:  val?.userId,
      groups: val?.groups
    };
    workspaceAPI.updateTeam(teams, workspaceId).then(
      (data) => {
        getWorkspace && getWorkspace();
        dispatch(getWorkspaceById(workspaceId));
        dispatch(getCurrentAssignees(workspaceId));
        setLoading(false);
        setAddTeamMemberModal(false);
        assigneeForm.resetFields();
        KoToast.success('Assignee updated successfully');
      },
      (err) => {
        setLoading(false);
      }
    );

  };


  const deleteTeamMember = () => {
    setLoading(true);
    let q = {
      userId: currentRecord?.userId
    };
    workspaceAPI.deleteTeamMember(workspaceId, q).then(
      (data) => {
        dispatch(getCurrentAssignees(workspaceId));
        setDeleteModal(false);
        setLoading(false);
        KoToast.success('Assignee deleted successfully');
      },
      (err) => {
        KoToast.error(err?.message);
        setLoading(false);
      }
    );
  };

  const deleteGroups = () => {
    setLoading(true);
   
    workspaceAPI.deleteGroup(workspaceId, currentRecord?.groupId).then(
      (data) => {
        dispatch(getCurrentAssignees(workspaceId));
        setDeleteGroupModal(false);
        setLoading(false);
        KoToast.success('Group deleted successfully');
      },
      (err) => {
        KoToast.error(err?.message);
        setLoading(false);
      }
    );
  };

  const Managers = ({ value, onChange }) =>
    <KoUserSelect value={value} onChange={v => onChange(v)} mode="multiple" users={orgUsers} placeholder='Select Team Members' />;


  const Groups = ({ value, onChange }) =>

    <KoSelect mode="multiple" value={value}
      showSearch
      allowClear
      onChange={v => { onChange(v); }}
      placeholder='Select Groups'
      options={groups?.data?.map((group) => ({
        label: group.name,
        value: group?.groupId
      }))}
    />;

  const meta = {
    columns: 4,
    formItemLayout: null,
    initialValues: currentRecord,
    colon: true,
    fields: [
      {
        key: 'userId', label: 'Add Team Members', colSpan: 2,
        widget: Managers
      },

      {
        key: 'groups', label: 'Add Groups', colSpan: 2,
        widget: Groups
      }
    ]
  };


  // const selectUser = (user) => {
  //   setCurrentRecord(user);
  // };

  const searchUser = (value) => {
    if (value) {
      let data = dataSource.filter(user => user?.profile?.firstName?.toLowerCase().includes(value.toLowerCase()) || user?.profile?.lastName?.toLowerCase().includes(value.toLowerCase()));
      setDataSource(data);
    } else {
      setDataSource(currentAssignees['data']);
    }
  };

  const columnsRight = [{
    title: '',
    dataIndex: 'x',
    key: 'x',
    fixed: 'right',
    width: 40,
    render: (text, row) => {
      return <div className={`${styles.circle} tableBtn columnsRight`} onClick={() => setCurrentRecord(row)}>
        {row?.userId !== createdBy && <KoTooltips title={'Delete'}>
          <KoButton className={'btn'} iconBtn={true} icon={<KoIcon width={14} height={14} name={'DeleteOutlined'} />} onClick={() => setDeleteModal(true)} />
        </KoTooltips>}
      </div>;
    }
  }];

  const columnsGroupsRight = [{
    title: '',
    dataIndex: 'x',
    key: 'x',
    fixed: 'right',
    width: 40,
    render: (text, row) => {
      return <div className={`${styles.circle} tableBtn columnsRight`} onClick={() => setCurrentRecord(row)}>
        {row?.userId !== createdBy && <KoTooltips title={'Delete'}>
          <KoButton className={'btn'} iconBtn={true} icon={<KoIcon width={14} height={14} name={'DeleteOutlined'} />} onClick={() => setDeleteGroupModal(true)} />
        </KoTooltips>}
      </div>;
    }
  }];

  return (
    <>
      <div className={styles.wrapper}>
        {isLoading && <KoLoader />}
        <div className={`tableCard ${styles.groups}`}>
          <div className={styles.headerFilter}>
            <KoTitle level={4} text={`Manage Teams`} />
            <div className={styles.searchOption}>
              <KoSearch allowClear onChange={e => searchUser(e.target.value)} placeholder='Search by name' />
              <KoButton label={'Add Groups'} type={'primary'} onClick={() => setAddTeamMemberModal(true)} />
            </div>
          </div>
          <KoTable rowKey='groupId'
            data={{ columns: COLUMNS_GROUPS, rows: wosGroups }}
            extraColumnsRight={columnsGroupsRight} maxHeight={60} />
        </div>

        <div className={'tableCard'}>
          <div className={styles.headerFilter}>
            <KoTitle level={4} text={`Manage Team Members`} />
            <div className={styles.searchOption}>
              <KoSearch allowClear onChange={e => searchUser(e.target.value)} placeholder='Search by name' />
              <KoButton label={'Add Team Member'} type={'primary'} onClick={() => setAddTeamMemberModal(true)} />
            </div>
          </div>
          <KoTable rowKey='userId'
            data={{ columns: COLUMNS_USERS, rows: dataSource }}
            extraColumnsRight={columnsRight} maxHeight={60} />
        </div>


      </div>
      
      <KoModal
        title={`Remove the user ${currentRecord?.profile?.firstName} from ${workspaceName?.toUpperCase()}`}
        centered
        open={isOpenDelete}
        afterClose={() => { setCurrentRecord(); }}
        handleOk={() => { setCurrentRecord(); setDeleteModal(false); }}
        onClose={() => { setCurrentRecord(); setDeleteModal(false); }}
        width={580}
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => setDeleteModal(!isOpenDelete)} />,
          <KoButton key='reset' loading={isLoading} color="danger" variant="solid" type='primary' label='Delete' onClick={() => deleteTeamMember()} />
        ]}
      >
        {isLoading && <KoLoader circle={false} />}
        <div className={styles.suspend}>
          <KoTitle level={5} text={`Are you sure you want to remove this user?`} />
          <KoText text={`This action is irreversible and will result in the removal of their associated data. ${workspaceName?.toUpperCase()} will no longer be part of this workspace`} />
        </div>
      </KoModal>


      <KoModal
        title={`Remove Group ${currentRecord?.name} from ${workspaceName?.toUpperCase()}`}
        centered
        open={isOpenGroupDelete}
        afterClose={() => { setCurrentRecord(); }}
        handleOk={() => { setCurrentRecord(); setDeleteGroupModal(false); }}
        onClose={() => { setCurrentRecord(); setDeleteGroupModal(false); }}
        width={580}
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => setDeleteGroupModal(!isOpenGroupDelete)} />,
          <KoButton key='reset' loading={isLoading} color="danger" variant="solid" type='primary' label='Delete' onClick={() => deleteGroups()} />
        ]}
      >
        {isLoading && <KoLoader circle={false} />}
        <div className={styles.suspend}>
          <KoTitle level={5} text={`Are you sure you want to remove this group?`} />
          <KoText text={`This action is irreversible and will result in the removal of their associated data. ${workspaceName?.toUpperCase()} will no longer be part of this workspace`} />
        </div>
      </KoModal>

      <KoModal
        title={`Add Groups / Users to ${workspaceName?.toUpperCase()}`}
        centered
        open={addTeamMemberModal}
        afterClose={() => { setCurrentRecord(); }}
        handleOk={() => { setCurrentRecord(); setAddTeamMemberModal(false); }}
        onClose={() => { setCurrentRecord(); setAddTeamMemberModal(false); }}
        width={'60%'}
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => setAddTeamMemberModal(false)} />,
          <KoButton key='reset' loading={isLoading} type='primary' label='Add' onClick={() => assigneeForm.submit()} />
        ]}
      >
        {isLoading && <KoLoader circle={false} />}
        <div className={styles.suspend}>
          <div className={styles.userForm}>
            <KoForm form={assigneeForm} layout="vertical" onFinish={handleAssigneeFinish}>
              <KoFormBuilder
                form={assigneeForm}
                meta={meta}
              />
            </KoForm>
          </div>
        </div>
      </KoModal>
    </>

  );
}

export default AssignesUpdate;
